import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useUIMode } from "../hooks/useUIMode";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import { useTranslation } from 'react-i18next';
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { formatDate } from '../utils/timeUtils';
import TemplateListView      from "./TemplateListView";
import NotifAdminDetailsView from "./NotifAdminDetailsView";
import NotifAdminNewView     from "./NotifAdminNewView";


const NotifAdmin = () => {

  const { t }    = useTranslation(["common"]);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const { uiMode, setUIMode, objDetails, setObjDetails } = useUIMode('LIST');

  const PAGE_STATE_STORAGE_KEY = "NotifAdmin.pageState";
  const defaultPageState = {
    searchField: 'SUBJECT',
    searchTerms: null,
    sortCol: null,
    sortDir: null,
    perPage: 25,
    currPage: 1
  };

  const [pageState, setPageState] = useState(() => {
    try {
      const savedPageState = sessionStorage.getItem(PAGE_STATE_STORAGE_KEY);
      return savedPageState
        ? { ...defaultPageState, ...JSON.parse(savedPageState) }
        : defaultPageState;
    } catch (error) {
      return defaultPageState;
    }
  });

  useEffect(() => {
    sessionStorage.setItem(PAGE_STATE_STORAGE_KEY, JSON.stringify(pageState));
  }, [pageState]);

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["NotifAdminDeleteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ----- Data Table stuff -----

  const tableColumns = [
    {
      igcColumnType: 'PRIMARY_ID',
      igcFieldName: 'id',
      name: t("I18N_Notif_id"),
      sortable: true,
      sortField: 'id',
      cell: null
    },
    {
      name: t("I18N_Subject"),
      selector: row => row.subject,
      grow: 3,
      wrap: true
    },
    {
      name: t("I18N_Type"),
      selector: row => row.typeName,
      sortable: true,
      sortField: 'typeName',
    },
    {
      name: t("I18N_Time_created"),
      selector: row => row.timeCreated,
      cell: row => (
        formatDate(row.timeCreated)
      ),
      sortable: true,
      sortField: 'timeCreated',
    },
    {
      igcColumnType: 'DELETE',
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: null
    }
  ];

  // ----- END - Data Table stuff -----

  const searchFieldOptions = [
    { key: "ID",      value: "ID" },
    { key: "SUBJECT", value: "SUBJECT" },
    { key: "TYPE",    value: "TYPE" }
  ];


  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <TemplateListView pageState={pageState}
                                                  axiosAPI={axiosAuth_DATA_MGMT_API}
                                                  apiObjName={'notifs'}
                                                  listPageTitle={t("I18N_Notif_Management")}
                                                  hideNewIcon={true}
                                                  searchTooltip={t("I18N_Search")}
                                                  deleteConfirmDialogTitle={t("I18N_Notif_delete_confirm")}
                                                  deleteObjTooltip={t("I18N_TIP_Delete_notif")}
                                                  deleteObjNameField={"id"}
                                                  tableColumns={tableColumns}
                                                  searchFieldOptions={searchFieldOptions}
                                                  deletePermission={'NotifAdminDeleteAccess'}
                                                  onUIMode={setUIMode}
                                                  onSetPageState={setPageState}
                                                  onSetObjDetails={setObjDetails}
                                                  purgeInfo={{purgeMethod:             'purge-notifs',
                                                              purgeButtonCaption:      t("I18N_Purge_notifs"),
                                                              purgeDialogTitle:        t("I18N_Purge_notifs"),
                                                              purgeConfirmDialogTitle: t("I18N_Purge_notif_confirm"),
                                                              defaultRetention:        30
                                                             }
                                                            }
                                /> : null}
      {(uiMode === 'DETAILS') ? <NotifAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <NotifAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default NotifAdmin;
